<div class="row" *ngFor="let news of data; last as isLast">
  <div class="col-12">
    <div class="ql-editor ck-content" [innerHTML]="news.html | safeHtml"></div>
    <hr class="separator" *ngIf="!isLast" />
  </div>
</div>
